import { ROUTER } from '../../constants/router';

export const MENU_KEY = {
    DATA_CATALOG: 'Data Catalog',
    DATA_INVENTORY: 'Data Inventory',
    RISK_MANAGEMENT: 'Risk Management',
    DPIA: 'DPIA',
    PRIVACY_POLICY: 'Policy',
    CONSENT_MANAGEMENT: 'Consent Management',
    COOKIE_MANAGEMENT: 'Cookie Management',
    DATA_SUBJECT_MANAGEMENT: 'Data Subject 360',
    DATA_INQUIRY: 'Data Inquiry',
    DATA_BREACH: 'Data Breach',
    CONFIGURATION: 'Configuration',
};

export const SUBMENU_KEY = {
    DATA_INVENTORY: {
        DASHBOARD: 'Dashboard',
        DATAFLOW: 'Data Flow',
        ROPA: 'RoPA',
    },
    RISK_MANAGEMENT: {
        DASHBOARD: 'Dashboard',
        RISK_ASSESSMENT: 'Risk Assessment',
        RISK_REGISTER: 'Risk Register',
    },
    COOKIE_MANAGEMENT: {
        DASHBOARD: 'Dashboard',
        COOKIE_SCANNER: 'Cookie Scanner',
        COOKIE_CATEGORY: 'Cookie Category',
        CUSTOMIZE_BANNER: 'Cookie Banner',
    },
    DATA_SUBJECT_MANAGEMENT: {
        DASHBOARD: 'Dashboard',
        MY_TASK: 'My Task',
        DS_REQUEST_FORM: 'DS Request Form',
        WORKFLOW: 'Workflow',
        IMPORT_DS_REQUEST: 'Import DS Request',
    },
    CONSENT_MANAGEMENT: {
        DASHBOARD: 'Dashboard',
        CONSENT_FORM: 'Consent Form',
        TEMPLATE_DESIGN: 'Template Design',
        MANAGE_CONSENT: 'Manage Consent',
        IMPORT_CONSENT: 'Import Consent',
    },
    DATA_BREACH: {
        DASHBOARD: 'Dashboard',
        DATA_BREACH_LOG: 'Data Breach Log',
        DATA_BREACH_FORM: 'Data Breach Form',
        RESPONSIBILITY: 'Responsibility',
    },
    CONFIGURATION: {
        USER_MANAGEMENT: 'User Management',
        DC_DPO: 'DC & DPO',
        DATA_CATALOG: 'Data Catalog',
        YOUR_PLAN: 'Your Plan',
        EMAIL_SETTING: 'Email Setting',
    },
};

export const MAP_LINK = [
    {
        mainMenuName: MENU_KEY.DATA_INVENTORY,
        subMenuList: [
            {
                subMenuName: SUBMENU_KEY.DATA_INVENTORY.DASHBOARD,
                link: ROUTER.DS_INVENTORY.DASHBOARD,
            },
            {
                subMenuName: SUBMENU_KEY.DATA_INVENTORY.DATAFLOW,
                link: ROUTER.DS_INVENTORY.DATAFLOW,
            },
            {
                subMenuName: SUBMENU_KEY.DATA_INVENTORY.ROPA,
                link: ROUTER.DS_INVENTORY.ROPA,
            },
        ],
    },
    {
        mainMenuName: MENU_KEY.RISK_MANAGEMENT,
        subMenuList: [
            {
                subMenuName: SUBMENU_KEY.RISK_MANAGEMENT.DASHBOARD,
                link: ROUTER.RISK_MANAGEMENT.DASHBOARD,
            },
            {
                subMenuName: SUBMENU_KEY.RISK_MANAGEMENT.RISK_ASSESSMENT,
                link: ROUTER.RISK_MANAGEMENT.RA,
            },
            {
                subMenuName: SUBMENU_KEY.RISK_MANAGEMENT.RISK_REGISTER,
                link: ROUTER.RISK_MANAGEMENT.RR,
            },
        ],
    },
    {
        mainMenuName: MENU_KEY.COOKIE_MANAGEMENT,
        subMenuList: [
            {
                subMenuName: SUBMENU_KEY.COOKIE_MANAGEMENT.DASHBOARD,
                link: ROUTER.COOKIE_MANAGEMENT.DASHBOARD,
            },
            {
                subMenuName: SUBMENU_KEY.COOKIE_MANAGEMENT.COOKIE_SCANNER,
                link: ROUTER.COOKIE_MANAGEMENT.COOKIE_SCANNER,
            },
            {
                subMenuName: SUBMENU_KEY.COOKIE_MANAGEMENT.COOKIE_CATEGORY,
                link: ROUTER.COOKIE_MANAGEMENT.COOKIE_CATEGORY,
            },
            {
                subMenuName: SUBMENU_KEY.COOKIE_MANAGEMENT.CUSTOMIZE_BANNER,
                link: ROUTER.COOKIE_MANAGEMENT.CUSTOMIZE_BANNER,
            },
        ],
    },
    {
        mainMenuName: MENU_KEY.DATA_SUBJECT_MANAGEMENT,
        subMenuList: [
            {
                subMenuName: SUBMENU_KEY.DATA_SUBJECT_MANAGEMENT.DASHBOARD,
                link: ROUTER.DS_360.DASHBOARD,
            },
            {
                subMenuName: SUBMENU_KEY.DATA_SUBJECT_MANAGEMENT.MY_TASK,
                link: ROUTER.DS_360.MY_TASK,
            },
            {
                subMenuName:
                    SUBMENU_KEY.DATA_SUBJECT_MANAGEMENT.DS_REQUEST_FORM,
                link: ROUTER.DS_360.DS_REQUEST_FORM,
            },
            {
                subMenuName: SUBMENU_KEY.DATA_SUBJECT_MANAGEMENT.WORKFLOW,
                link: ROUTER.DS_360.WORKFLOW,
            },
            {
                subMenuName:
                    SUBMENU_KEY.DATA_SUBJECT_MANAGEMENT.IMPORT_DS_REQUEST,
                link: ROUTER.DS_360.IMPORT_DS_REQUEST,
            },
        ],
    },
    {
        mainMenuName: MENU_KEY.CONSENT_MANAGEMENT,
        subMenuList: [
            {
                subMenuName: SUBMENU_KEY.CONSENT_MANAGEMENT.DASHBOARD,
                link: ROUTER.CONSENT_MANAGEMENT.DASHBOARD,
            },
            {
                subMenuName: SUBMENU_KEY.CONSENT_MANAGEMENT.CONSENT_FORM,
                link: ROUTER.CONSENT_MANAGEMENT.CONSENT,
            },
            {
                subMenuName: SUBMENU_KEY.CONSENT_MANAGEMENT.TEMPLATE_DESIGN,
                link: ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN,
            },
            {
                subMenuName: SUBMENU_KEY.CONSENT_MANAGEMENT.MANAGE_CONSENT,
                link: ROUTER.CONSENT_MANAGEMENT.MANANGE_CONSENT,
            },
            {
                subMenuName: SUBMENU_KEY.CONSENT_MANAGEMENT.IMPORT_CONSENT,
                link: ROUTER.CONSENT_MANAGEMENT.IMPORT_CONSENT,
            },
        ],
    },
    {
        mainMenuName: MENU_KEY.DATA_BREACH,
        subMenuList: [
            {
                subMenuName: SUBMENU_KEY.DATA_BREACH.DASHBOARD,
                link: ROUTER.DATA_BREACH.DASHBOARD,
            },
            {
                subMenuName: SUBMENU_KEY.DATA_BREACH.DATA_BREACH_LOG,
                link: ROUTER.DATA_BREACH.LOG,
            },
            {
                subMenuName: SUBMENU_KEY.DATA_BREACH.DATA_BREACH_FORM,
                link: ROUTER.DATA_BREACH.FORM,
            },
            {
                subMenuName: SUBMENU_KEY.DATA_BREACH.RESPONSIBILITY,
                link: ROUTER.DATA_BREACH.RESPONSIBILITY,
            },
        ],
    },
    {
        mainMenuName: MENU_KEY.CONFIGURATION,
        subMenuList: [
            {
                subMenuName: SUBMENU_KEY.CONFIGURATION.USER_MANAGEMENT,
                link: ROUTER.CONFIGURATION.USER_MANAGEMENT,
            },
            {
                subMenuName: SUBMENU_KEY.CONFIGURATION.DC_DPO,
                link: ROUTER.CONFIGURATION.DC_DPO,
            },
            {
                subMenuName: SUBMENU_KEY.CONFIGURATION.DATA_CATALOG,
                link: ROUTER.CONFIGURATION.DATA_CATALOG,
            },
            {
                subMenuName: SUBMENU_KEY.CONFIGURATION.YOUR_PLAN,
                link: ROUTER.CONFIGURATION.YOUR_PLAN,
            },
            {
                subMenuName: SUBMENU_KEY.CONFIGURATION.EMAIL_SETTING,
                link: ROUTER.CONFIGURATION.EMAIL_SETTING,
            },
        ],
    },
];
